export default __webpack_public_path__ + "static/media/Prepodobnaya_Nadezhda_Aleksandrovna.827dd5cb.webp";